/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: SuccessStoriesPage
 * Page name: Success Strories page
 * Page Description: This is the success story page of the website of Ekathva Innovations.
 */

import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import LandingPageSuccessStories from "components/Headers/LandingPageSuccessStories";
import Navbar from "components/Navbars/Navbar";
import Footer from "components/Footers/Footer";
//pages
import "assets/style/Style.css";
import data from "../api/json/successStories.json";
import SuccessStoriesData from "./SuccessStoriesData";

class SuccessStories extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // this is needed, because InfiniteCalendar forces window scroll
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <MetaTags>
          <title>
            Success Stories - Our works | Ekathva Innovations Pvt Ltd
          </title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          ></meta>
        </MetaTags>
        <Navbar />
        <LandingPageSuccessStories />
        <br />
        <br />
        <br />

        <SuccessStoriesData data={data} />
        <Footer />
      </div>
    );
  }
}

export default SuccessStories;
